import { Icon } from '@/components/Icon'
import { Loading3QuartersOutlined } from '@ant-design/icons'
import styles from './styles.module.scss'

export function PageSpinner() {
  return (
    <div className={styles.spinner}>
      <Icon icon={<Loading3QuartersOutlined spin />} size="2.25rem" color="primary" />
    </div>
  )
}
